import { render, staticRenderFns } from "./DeviceExcursionTable.vue?vue&type=template&id=1b5e0d74&scoped=true"
import script from "./DeviceExcursionTable.vue?vue&type=script&lang=js"
export * from "./DeviceExcursionTable.vue?vue&type=script&lang=js"
import style0 from "./DeviceExcursionTable.vue?vue&type=style&index=0&id=1b5e0d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5e0d74",
  null
  
)

/* custom blocks */
import block0 from "./DeviceExcursionTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports